import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style.module.scss';

const OfflineNotice = () => {
  const { t } = useTranslation();
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className={Style.bar} role="alert">
      <span className={Style.dot} />
      <span>{t('noInternetText')}</span>
    </div>
  );
};

export default OfflineNotice;
